import { createSlice } from "@reduxjs/toolkit";
import {
  getContractInvoiceListThunk,
  updateContractInvoiceStatusThunk,
} from "state/action/contract_invoice";

const async0 = () => ({
  data: null,
  isPending: false,
  isFulfilled: false,
  isRejected: false,
  err: null,
});

const pending = (s) => ({
  ...s,
  data: null,
  isPending: true,
  isFulfilled: false,
  isRejected: false,
  err: null,
});
const fulfilled = (s, a) => ({
  ...s,
  data: a.payload,
  isPending: false,
  isFulfilled: true,
  isRejected: false,
  err: null,
});
const rejected = (s, a) => ({
  ...s,
  data: null,
  isPending: false,
  isFulfilled: false,
  isRejected: true,
  err: a.error.message,
});

const initialState = {
  getContractInvoices: async0(),
  updateContractInvoiceStatus: async0(),
  selectedContractInvoice: null,
};

const contractInvoiceSlice = createSlice({
  name: "contractInvoice",
  initialState,
  reducers: {
    setSelectedContractInvoice: (state, action) => {
      state.selectedContractInvoice = action.payload;
    },
    clearContractInvoiceState: () => initialState,
  },
  extraReducers(builder) {
    const cases = [
      [getContractInvoiceListThunk, "getContractInvoices"],
      [updateContractInvoiceStatusThunk, "updateContractInvoiceStatus"],
    ];
    for (const [thunk, key] of cases) {
      builder
        .addCase(thunk.pending, (state) => {
          state[key] = pending(state[key]);
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state[key] = fulfilled(state[key], action);
        })
        .addCase(thunk.rejected, (state, action) => {
          state[key] = rejected(state[key], action);
        });
    }
  },
});

export const contractInvoiceAction = {
  ...contractInvoiceSlice.actions,
  getContractInvoiceListThunk,
  updateContractInvoiceStatusThunk,
};

export const selectContractInvoice = (state) => state?.contractInvoice;

export default contractInvoiceSlice.reducer;
